<template>
  <v-container class="modern-work-order-update">
    <!-- Premium Global Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="48" class="mr-4 shadow-sm">
          <v-icon color="white" small>fas fa-pen-nib</v-icon>
        </v-avatar>
        <div>
          <div class="text-h4 font-weight-black primary--text d-flex align-center lh-1">
            OT #{{ work_order.id }}
            <v-chip color="primary lighten-4" text-color="primary darken-2" label x-small class="ml-4 font-weight-black tracking-widest shadow-xs">MÓDULO DE EDICIÓN</v-chip>
          </div>
          <div v-if="work_order.created_by" class="caption grey--text font-weight-bold uppercase tracking-wider mt-1">
            <v-icon x-small class="mr-1 grey--text">fas fa-user-circle</v-icon>
            Creada por: <span class="primary--text">{{ work_order.created_by.full_name || (work_order.created_by.first_name + ' ' + work_order.created_by.last_name) }}</span> • {{ work_order.created_at | moment('DD/MM/YYYY') }}
          </div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center gap-3">
        <v-btn depressed color="primary" large class="px-8 shadow-md rounded-lg font-weight-black text-uppercase tracking-wider" :loading="loading" @click="save">
          <v-icon small class="mr-2">fas fa-save</v-icon> Guardar Cambios
        </v-btn>
        <v-btn icon color="grey darken-2" class="grey lighten-4 shadow-sm" @click="$router.go(-1)">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </div>
    </v-row>

    <!-- General Info Cards -->
    <v-row>
      <v-col cols="12" md="8">
        <v-card outlined class="modern-card overflow-hidden mb-6 shadow-sm">
          <v-sheet color="primary" class="px-6 py-3 border-bottom d-flex align-center">
            <v-icon small color="white" class="mr-3">fas fa-info-circle</v-icon>
            <span class="text-subtitle-2 font-weight-bold white--text text-uppercase tracking-wider">Información General del Proyecto</span>
          </v-sheet>
          <v-card-text class="pa-6">
            <v-row dense>
              <v-col cols="12">
                <v-text-field 
                  v-model="work_order.name"
                  label="Nombre del Proyecto"
                  outlined dense hide-details="auto"
                  readonly filled
                  class="modern-input mb-4"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="work_order.customer_name"
                  label="Cliente"
                  outlined dense hide-details="auto"
                  readonly filled
                  class="modern-input"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="work_order.sales_note"
                  label="Nota de Venta Origen"
                  outlined dense hide-details="auto"
                  readonly filled
                  class="modern-input"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="modern-card overflow-hidden shadow-sm">
          <v-sheet color="indigo darken-2" class="px-6 py-3 border-bottom d-flex align-center">
            <v-icon small color="white" class="mr-3">fas fa-truck-loading</v-icon>
            <span class="text-subtitle-2 font-weight-bold white--text text-uppercase tracking-wider">Logística y Despacho</span>
          </v-sheet>
          <v-card-text class="pa-6">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="work_order.purchase_order"
                  label="Orden de Compra (OC)"
                  outlined dense hide-details="auto"
                  class="modern-input mb-4"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="work_order.delivery_type"
                  :items="deliveryTypeList"
                  item-text="name"
                  item-value="value"
                  label="Método de Entrega"
                  outlined dense hide-details="auto"
                  class="modern-select mb-4"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Compromiso Entrega"
                  :value="formatedDeliveryDate"
                  @change="changeDeliveryDate"
                  type="datetime-local"
                  outlined dense hide-details="auto"
                  class="modern-input"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Instalación"
                  :value="formatedInstallDate"
                  @change="changeInstallDate"
                  type="datetime-local"
                  outlined dense hide-details="auto"
                  clearable
                  class="modern-input"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Desinstalación"
                  :value="formatedUninstallDate"
                  @change="changeUninstallDate"
                  type="datetime-local"
                  outlined dense hide-details="auto"
                  clearable
                  class="modern-input"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
 
      <v-col cols="12" md="4">
        <v-card outlined class="modern-card overflow-hidden shadow-sm fill-height d-flex flex-column">
          <v-sheet color="grey darken-3" class="px-6 py-3 border-bottom d-flex align-center">
            <v-icon small color="white" class="mr-3">fas fa-sticky-note</v-icon>
            <span class="text-subtitle-2 font-weight-bold white--text text-uppercase tracking-wider">Observaciones</span>
          </v-sheet>
          <v-card-text class="pa-6 flex-grow-1">
            <v-textarea
              v-model="work_order.notes"
              outlined dense
              placeholder="Ingrese aquí notas internas relevantes..."
              rows="12"
              class="modern-input fill-height-textarea"
              hide-details
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Products in Production Section -->
    <v-row class="mt-8">
      <v-col cols="12">
        <v-card outlined class="modern-card overflow-hidden shadow-sm">
          <v-sheet color="grey lighten-4" class="px-6 py-4 border-bottom d-flex align-center">
            <v-icon small color="primary" class="mr-3">fas fa-box-open</v-icon>
            <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2 text-uppercase tracking-wider">Productos en Orden de Trabajo</span>
            <v-spacer></v-spacer>
            <v-btn small color="primary" depressed class="rounded-lg px-4" @click="addingCost = true">
              <v-icon x-small class="mr-2">fas fa-plus</v-icon> Agregar Costo Extra
            </v-btn>
          </v-sheet>
 
          <v-data-table
            :headers="productsTableHeaders"
            :items="work_order.products"
            item-key="id"
            show-expand
            single-expand
            class="modern-table elevation-0"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:header.item="{ header }">
              <span class="font-weight-black text-uppercase tracking-widest caption">{{ header.text }}</span>
            </template>
            <template v-slot:header.name="{ header }">
              <span class="font-weight-black text-uppercase tracking-widest caption">{{ header.text }}</span>
            </template>
            <template v-slot:header.qty="{ header }">
              <span class="font-weight-black text-uppercase tracking-widest caption">{{ header.text }}</span>
            </template>
            <template v-slot:header.width="{ header }">
              <span class="font-weight-black text-uppercase tracking-widest caption">{{ header.text }}</span>
            </template>
            <template v-slot:header.height="{ header }">
              <span class="font-weight-black text-uppercase tracking-widest caption">{{ header.text }}</span>
            </template>
            <template v-slot:header.totalMts2="{ header }">
              <span class="font-weight-black text-uppercase tracking-widest caption">{{ header.text }}</span>
            </template>
            <template v-slot:header.actions="{ header }">
              <span class="font-weight-black text-uppercase tracking-widest caption">{{ header.text }}</span>
            </template>

            <!-- Custom Item Display -->
            <template v-slot:item.item="{ item }">
              <v-avatar size="24" color="grey lighten-4" class="font-weight-black grey--text text--darken-2 caption border shadow-xs">
                {{ work_order.products.indexOf(item) + 1 }}
              </v-avatar>
            </template>
 
            <template v-slot:item.name="{ item }">
              <div class="d-flex align-center py-2">
                <v-tooltip v-if="item.change" top color="error">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small color="error" class="mr-2 pulse-icon">fas fa-exclamation-circle</v-icon>
                  </template>
                  <span>Producto modificado manualmente</span>
                </v-tooltip>
                <span :class="{ 'to-delete font-weight-black opacity-40': item.delete, 'body-2 font-weight-black primary--text': true }">
                  {{ item.name }}
                </span>
              </div>
            </template>
 
            <template v-slot:item.width="{ item }"><span class="font-weight-medium">{{ item.width | number('0.00') }}</span></template>
            <template v-slot:item.height="{ item }"><span class="font-weight-medium">{{ item.height | number('0.00') }}</span></template>
            <template v-slot:item.qty="{ item }">
              <v-chip dark small :color="item.completed ? 'success' : 'primary'" class="font-weight-black shadow-xs">
                {{ item.qty }}
              </v-chip>
            </template>
            <template v-slot:item.totalMts2="{ item }">
              <v-chip x-small label outlined color="grey darken-1" class="font-weight-bold">
                {{ item.mts2 | number('0.00') }} m²
              </v-chip>
            </template>
 
            <template v-slot:item.actions="{ item }">
              <div class="d-flex justify-center gap-2">
                <v-btn icon small color="primary" class="grey lighten-4 shadow-sm" @click="editProduct(item)" :disabled="item.completed">
                  <v-icon x-small>fas fa-pen</v-icon>
                </v-btn>
                <v-btn icon small color="error" class="grey lighten-4 shadow-sm" @click="deleteProduct(item)" :disabled="item.completed || work_order.products.length < 2 || item.delete">
                  <v-icon x-small>fas fa-trash-alt</v-icon>
                </v-btn>
              </div>
            </template>
 
            <!-- Expandable Row -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-0 expanded-row-container">
                <div class="pa-6 border-left-primary bg-grey-light">
                  <v-card outlined class="modern-card elevation-2 overflow-hidden bg-white">
                    <div class="px-6 py-3 border-bottom d-flex align-center bg-grey-light">
                      <v-icon x-small color="primary" class="mr-3">fas fa-route</v-icon>
                      <span class="caption font-weight-black text-uppercase tracking-wider grey--text text--darken-2">Flujo de Producción y Trazabilidad</span>
                      <v-spacer></v-spacer>
                      <div v-if="item.notes" class="body-2 grey--text text-italic font-weight-medium">
                        <v-icon x-small class="mr-1">fas fa-comment-dots</v-icon> {{ item.notes }}
                      </div>
                    </div>
                    <v-simple-table dense class="modern-table">
                      <thead>
                        <tr class="bg-grey-light">
                          <th class="caption font-weight-black text-uppercase py-3">Secuencia</th>
                          <th class="caption font-weight-black text-uppercase py-3">Nombre del Proceso</th>
                          <th class="caption font-weight-black text-uppercase py-3">Fecha Estimada</th>
                          <th class="caption font-weight-black text-uppercase py-3 text-center">Estado de Avance</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(process, idx) in item.process_orders" :key="idx" :class="{ 'completed-row opacity-60 bg-success-light': process.completed }">
                          <td class="caption font-weight-black">#{{ idx + 1 }}</td>
                          <td class="body-2 font-weight-bold grey--text text--darken-3">{{ process.name }}</td>
                          <td class="caption font-weight-black grey--text">{{ process.estimated | moment("DD/MMM/YYYY") }}</td>
                          <td class="text-center">
                            <v-chip x-small label :color="process.completed ? 'success' : 'accent'" dark class="font-weight-black tracking-widest">
                              {{ process.completed ? 'FINALIZADO' : 'PENDIENTE' }}
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Additional Costs Section -->
        <v-card outlined class="modern-card overflow-hidden shadow-sm">
          <v-sheet color="grey darken-3" class="px-6 py-3 border-bottom d-flex align-center">
            <v-icon small color="white" class="mr-3">fas fa-coins</v-icon>
            <span class="text-subtitle-2 font-weight-bold white--text text-uppercase tracking-wider">Costos Adicionales Registrados</span>
          </v-sheet>
          <v-data-table
            :headers="additionalCostsHeaders"
            :items="work_order.additional_costs"
            hide-default-footer
            class="modern-table elevation-0"
          >
            <template v-slot:item.price="{ item }">
              <span class="font-weight-black success--text">{{ item.price | moneda }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon small color="error" class="grey lighten-4 shadow-sm" @click="deleteCost(item)">
                <v-icon x-small>fas fa-trash-alt</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>

    <!-- Edit Product Modal -->
    <v-dialog v-model="editingProduct" max-width="600" persistent transition="dialog-bottom-transition">
      <v-card outlined class="modern-card overflow-hidden elevation-24">
        <v-sheet color="primary" class="pa-6 d-flex align-center shadow-sm">
          <v-avatar color="primary lighten-1" size="32" class="mr-3">
            <v-icon small color="white">fas fa-edit</v-icon>
          </v-avatar>
          <span class="text-h6 font-weight-black white--text text-uppercase tracking-widest">Ajustes del Producto</span>
          <v-spacer></v-spacer>
          <v-btn icon color="white" small @click="editingProduct = false" class="grey lighten-1 opacity-20">
            <v-icon x-small>fas fa-times</v-icon>
          </v-btn>
        </v-sheet>
        
        <v-card-text class="pa-8">
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(saveProduct)">
              <div class="pa-6 rounded-xl border-dashed mb-8 text-center bg-grey-light">
                <div class="caption primary--text font-weight-black text-uppercase tracking-widest mb-1">Producto Identificado</div>
                <div class="text-h6 font-weight-black secondary--text tracking-tight">{{ newProduct.name }}</div>
              </div>
              
              <v-row dense class="mb-4">
                <v-col cols="12">
                  <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="newProduct.name" label="Etiqueta / Descripción" outlined dense class="modern-input mb-4" :error-messages="errors" />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider name="Ancho" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="newProduct.width" label="Ancho (cm)" type="number" outlined dense class="modern-input" :error-messages="errors" />
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider name="Alto" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="newProduct.height" label="Alto (cm)" type="number" outlined dense class="modern-input" :error-messages="errors" />
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row dense class="mb-4">
                <v-col cols="12">
                  <ValidationProvider name="Cantidad" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="newProduct.qty" label="Cantidad Ordenada" type="number" outlined dense class="modern-input" :error-messages="errors" />
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-textarea v-model="newProduct.notes" label="Instrucciones Técnicas / Observaciones" outlined rows="3" class="modern-input mb-8" placeholder="..." />
              
              <v-btn block color="primary" large depressed class="py-6 rounded-lg font-weight-black text-uppercase tracking-widest shadow-md" type="submit">
                <v-icon small left>fas fa-check-double</v-icon> Confirmar Cambios
              </v-btn>
            </v-form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Additional Cost Modal -->
    <v-dialog v-model="addingCost" max-width="500" persistent>
      <cost-create-update @close="addingCost = false" @save="addCost" :custom="false" :global="false" :workOrder="true" :cost="newWorkOrderCost" />
    </v-dialog>

  </v-container>
</template>

<script>
import { updateWorkOrder, getWorkOrder } from '@/api/production'
import notifications from '@/utils/notifications'
import CostCreateUpdate from '@/components/products/costs/CostCreateUpdate'
import moment from 'moment'

export default {
  name: 'WorkOrderUpdate',
  components: { CostCreateUpdate },
  data() {
    return {
      work_order: { products: [], additional_costs: [] },
      productsTableHeaders: [
        { text: '', value: 'data-table-expand', class: 'grey lighten-4', width: '48' },
        { text: 'Item', value: 'item', class: 'grey lighten-4', align: 'center', width: '60' },
        { text: 'Descripción del Producto', value: 'name', class: 'grey lighten-4' },
        { text: 'Cant.', value: 'qty', class: 'grey lighten-4', align: 'center', width: '90' },
        { text: 'Ancho (cm)', value: 'width', class: 'grey lighten-4', align: 'end', width: '110' },
        { text: 'Alto (cm)', value: 'height', class: 'grey lighten-4', align: 'end', width: '110' },
        { text: 'Total m²', value: 'totalMts2', class: 'grey lighten-4', align: 'end', width: '120' },
        { text: 'Acciones', value: 'actions', class: 'grey lighten-4', align: 'center', width: '120', sortable: false },
      ],
      deliveryTypeList: [
        { name: '🚚 Despacho Directo', value: 0 },
        { name: '🏪 Retira el Cliente', value: 1 },
        { name: '🛠️ Retira Instalador', value: 2 },
      ],
      editingProduct: false,
      newProduct: {},
      loading: false,
      addingCost: false,
      newWorkOrderCost: { id: -1, unit: '', name: '', price: 0, min_price: 0, is_supply: true, has_article: false, price_update_option: 0, cost_unit: { name: '' } },
      costLoading: false,
      additionalCostsHeaders: [
        { text: 'Acciones', value: 'actions', class: 'grey lighten-5', width: '80', align: 'center' },
        { text: 'Concepto / Descripción', value: 'name', class: 'grey lighten-5' },
        { text: 'Monto Unitario', value: 'price', class: 'grey lighten-5', align: 'end' },
      ],
    }
  },
  computed: {
    formatedDeliveryDate() { return this.work_order.delivery_date ? moment(this.work_order.delivery_date).format('yyyy-MM-DDTHH:mm') : '' },
    formatedInstallDate() { return this.work_order.install_date ? moment(this.work_order.install_date).format('yyyy-MM-DDTHH:mm') : '' },
    formatedUninstallDate() { return this.work_order.uninstall_date ? moment(this.work_order.uninstall_date).format('yyyy-MM-DDTHH:mm') : '' },
  },
  methods: {
    changeDeliveryDate(val) { this.work_order.delivery_date = val },
    changeInstallDate(val) { this.work_order.install_date = val },
    changeUninstallDate(val) { this.work_order.uninstall_date = val },
    editProduct(item) {
      this.editingProduct = true
      this.newProduct = { ...item }
    },
    saveProduct() {
      const mts2 = this.newProduct.width * this.newProduct.height * this.newProduct.qty * 0.0001
      this.$set(this.newProduct, 'change', true)
      this.$set(this.newProduct, 'mts2', mts2)
      this.$set(this.newProduct, 'estimated', '')
      const idx = this.work_order.products.findIndex(p => p.id === this.newProduct.id)
      if (idx !== -1) {
        this.work_order.products.splice(idx, 1, this.newProduct)
      }
      this.editingProduct = false
      this.newProduct = {}
      notifications.showSuccess('Producto actualizado localmente')
    },
    deleteProduct(item) {
      item.delete = true
      const idx = this.work_order.products.findIndex(p => p.id === item.id)
      if (idx !== -1) {
        this.work_order.products.splice(idx, 1, item)
      }
      notifications.showWarn('Producto marcado para eliminación')
    },
    async save() {
      this.loading = true
      try {
        const payload = { ...this.work_order }
        payload.delivery_date = payload.delivery_date ? new Date(payload.delivery_date).toISOString() : null
        payload.install_date = payload.install_date ? new Date(payload.install_date).toISOString() : null
        payload.uninstall_date = payload.uninstall_date ? new Date(payload.uninstall_date).toISOString() : null
        payload.justUpdateCost = false

        const data = await updateWorkOrder(payload)
        if (data.status) {
          notifications.showSuccess(`OT #${data.work_order} actualizada exitosamente`)
        } else {
          notifications.showWarn(`OT #${data.work_order} actualizada con alertas de inventario`)
        }
        this.$router.push({ name: 'WorkOrders' })
      } catch (e) {
        notifications.showError('Error al guardar: ' + e)
      } finally {
        this.loading = false
      }
    },
    async deleteCost(item) {
      const index = this.work_order.additional_costs.indexOf(item)
      this.work_order.additional_costs.splice(index, 1)
    },
    async addCost(item) {
      const cost = { name: item.name, price: item.price }
      if (!this.work_order.additional_costs) this.work_order.additional_costs = []
      this.work_order.additional_costs.push(cost)
    },
  },
  async created() {
    this.loading = true
    try {
      const res = await getWorkOrder(this.$route.params.id)
      this.work_order = res
      this.work_order.products.forEach(product => {
        product.change = false
        product.delete = false
      })
    } catch (e) {
      notifications.showError('Error al cargar OT: ' + e)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.modern-work-order-update { padding-bottom: 80px; }
.modern-card { border: 1px solid rgba(0,0,0,0.08) !important; border-radius: 12px !important; background-color: #fff; }
.shadow-md { box-shadow: 0 4px 12px rgba(var(--v-primary-base), 0.2) !important; }
.shadow-sm { box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.03) !important; }
.bg-grey-light { background-color: #f8f9fa; }
.bg-success-light { background-color: rgba(var(--v-success-base), 0.05); }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08); }
.border-dashed { border: 2px dashed rgba(var(--v-primary-base), 0.2); }
.border-left-primary { border-left: 4px solid var(--v-primary-base) !important; }
.gap-1 { gap: 4px; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.uppercase { text-transform: uppercase; }
.tracking-widest { letter-spacing: 2px; }
.tracking-wider { letter-spacing: 1px; }
.tracking-tight { letter-spacing: -0.5px; }
.opacity-20 { opacity: 0.2; }
.opacity-40 { opacity: 0.4; }
.opacity-60 { opacity: 0.6; }
.lh-1 { line-height: 1 !important; }
.to-delete { text-decoration: line-through; color: var(--v-error-base); }
.pulse-icon { animation: pulse 2s infinite; }
@keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
.modern-table >>> .v-data-table-header th { white-space: nowrap; height: 56px !important; }
.modern-table >>> td { padding: 16px !important; }
.expanded-row-container { background-color: #f1f3f5; }
.fill-height-textarea >>> .v-input__control, 
.fill-height-textarea >>> .v-input__slot, 
.fill-height-textarea >>> textarea { height: 100% !important; }
</style>